module.exports = __webpack_public_path__ + "img/07fd4e6.png";